import { render, staticRenderFns } from "./usersTable.vue?vue&type=template&id=4c05f179&scoped=true"
import script from "./usersTable.vue?vue&type=script&lang=js"
export * from "./usersTable.vue?vue&type=script&lang=js"
import style0 from "./usersTable.vue?vue&type=style&index=0&id=4c05f179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05f179",
  null
  
)

export default component.exports